import { NgModule } from '@angular/core';
import { SettingListComponent } from './setting-list/setting-list.component';
import { SettingEditComponent } from './setting-edit/setting-edit.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ExcelModule } from '@progress/kendo-angular-grid';

@NgModule({
  declarations: [
    SettingListComponent,
    SettingEditComponent
  ],
  imports: [
    SharedModule,
    ExcelModule
  ]
})
export class SettingModule { }
